import React, { useEffect } from 'react'
import { motion, useAnimation } from 'motion/react'

const SlidingDiv = ({ children }) => {
  const controls = useAnimation()

  useEffect(() => {
    controls.start({ y: 0, opacity: 1, transition: { duration: 0.5 } })
  }, [controls])

  return (
    <motion.div
      initial={{ y: -100, opacity: 0 }}
      animate={controls}
      className="absolute left-0 top-0 z-20 w-full">
      {children}
    </motion.div>
  )
}

export default SlidingDiv
